import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {AuthenticationService} from '../authentication.service';
import {environment} from '../../../../environments/environment.dev';

@Injectable()
export class RoleGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const POSSIBLE_ROLES = environment.userRoles.All;
        const authData = AuthenticationService.getStoredAuthData();
        const CURRENT_USER_ROLES: string[] = authData?.user?.roles ?? [];

        const roles = route.data.roles as Array<string>;

        if (!roles || !roles.length) {
            this.router.navigate(['/key-loans']);
            return false;
        }

        const hasAccess = roles.some(role => {
            if (POSSIBLE_ROLES.some(r => CURRENT_USER_ROLES.includes(r))) {
                return CURRENT_USER_ROLES.includes(role);
            }
            return false;
        });

        if (!hasAccess) {
            this.router.navigate(['/key-loans']);
        }

        return hasAccess;
    }
}
